/* KWD custom review widget - 2026-07-27.
   Data comes from Yotpo's public, no-auth widget endpoint:
     https://api-cdn.yotpo.com/v1/widget/{app_key}/products/{product_id}/reviews
   Yotpo remains the system of record. Its own widget is still on the page,
   hidden, and is revealed when someone clicks Write a review, so submitting,
   moderation and the review-request emails are all untouched.

   This one fetch feeds TWO things:
     1. the mini thermometer up by the product title (renderMini)
     2. the full review band under the description (render)

   Name policy: FIRST NAME ONLY. Yotpo returns display_name like "JOSEPH E." or
   "Elena C."; we take the first token and title-case it. Never render the
   surname or initial. Yotpo does not expose the reviewer's state in this
   endpoint, so no location is shown.

   Counts: derived from the reviews actually returned, NOT from bottomline.
   Yotpo's bottomline is cached and lags moderation by hours, so right after a
   review is hidden it still reports the old total. Trusting it showed a 1.0
   rating on a product whose only review had just been pulled. bottomline is now
   only a fallback for catalogues past the 100-per-page ceiling. */
(function () {
  var APP_KEY = 'jKprGhktBPow78oeAXWiLCuRo5llysxPxaKib3of';
  var PAGE = 4;
  var PER_PAGE = 100;

  var host = document.getElementById('kwd-reviews');
  if (!host) { return; }
  var productId = host.getAttribute('data-product-id');
  if (!productId) { return; }

  var state = { all: [], filter: 0, sort: 'recent', shown: PAGE, stats: null };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* "JOSEPH E." -> "Joseph".  "elena c." -> "Elena".  "" -> "Verified buyer". */
  function firstName(n) {
    if (!n) { return 'Verified buyer'; }
    var t = String(n).trim().split(/\s+/)[0].replace(/[^A-Za-z'\-]/g, '');
    if (!t) { return 'Verified buyer'; }
    return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
  }

  /* Build the summary from the reviews in hand. Only fall back to Yotpo's cached
     bottomline when we clearly did not receive the full set. */
  function computeStats(reviews, bottom) {
    var truncated = reviews.length >= PER_PAGE;
    if (truncated && bottom) {
      return {
        total: Number(bottom.total_review) || reviews.length,
        avg: Number(bottom.average_score) || 0,
        dist: bottom.star_distribution || {},
        verified: null
      };
    }
    var dist = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    var sum = 0, verified = 0;
    reviews.forEach(function (r) {
      var s = Math.round(Number(r.score) || 0);
      if (dist[s] != null) { dist[s]++; }
      sum += Number(r.score) || 0;
      if (r.verified_buyer) { verified++; }
    });
    return {
      total: reviews.length,
      avg: reviews.length ? (sum / reviews.length) : 0,
      dist: dist,
      verified: verified
    };
  }

  function stars(score, cls) {
    var n = Math.round(Number(score) || 0);
    var out = '<span class="' + (cls || 'kwd-rv-stars') + '" role="img" aria-label="' + n + ' out of 5 stars">';
    for (var i = 1; i <= 5; i++) {
      out += '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="' +
        (i <= n ? 'on' : 'off') +
        '" d="M12 2.6l2.9 5.9 6.5.9-4.7 4.6 1.1 6.4-5.8-3-5.8 3 1.1-6.4L2.6 9.4l6.5-.9z"/></svg>';
    }
    return out + '</span>';
  }

  function when(iso) {
    var d = new Date(iso);
    if (isNaN(d)) { return ''; }
    return d.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  }

  /* ---------- mini rating gauge, up by the product title ----------
     A liquid-glass capsule that fills to the score. No stars: the owner wants the
     bar to be the one rating element on the PDP, and Yotpo's default star row is
     hidden in CSS so there is never a second one.
     Injected before Yotpo's hidden .yotpo.bottomLine so it lands in that slot.
     Renders nothing at all when there are no reviews. */
  function renderMini(st) {
    if (!st || !st.total) { return; }
    var anchor = document.querySelector('.yotpo.bottomLine');
    if (!anchor || document.querySelector('.kwd-mini')) { return; }

    var pct = Math.max(0, Math.min(100, (st.avg / 5) * 100));
    var ticks = '';
    for (var t = 1; t <= 4; t++) { ticks += '<span style="bottom:' + (t * 20) + '%"></span>'; }

    var el = document.createElement('div');
    el.className = 'kwd-mini';
    el.setAttribute('role', 'img');
    el.setAttribute('aria-label', 'Rated ' + st.avg.toFixed(1) + ' out of 5 from ' + st.total + ' reviews');
    el.innerHTML =
      '<div class="kwd-mini-glass">' +
        '<div class="kwd-mini-liquid" data-fill="' + pct.toFixed(1) + '"><b></b></div>' +
        '<div class="kwd-mini-ticks">' + ticks + '</div>' +
        '<div class="kwd-mini-shine"></div>' +
      '</div>' +
      '<div class="kwd-mini-meta">' +
        '<div class="kwd-mini-top"><span class="kwd-mini-num">' + st.avg.toFixed(1) +
          '</span><span class="kwd-mini-of">/ 5</span></div>' +
        '<button type="button" class="kwd-mini-link">' + st.total +
          ' review' + (st.total === 1 ? '' : 's') + '</button>' +
      '</div>';

    anchor.parentNode.insertBefore(el, anchor);

    /* fill after paint so the liquid rises */
    var liq = el.querySelector('.kwd-mini-liquid');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { liq.style.height = liq.getAttribute('data-fill') + '%'; });
    });

    el.querySelector('.kwd-mini-link').addEventListener('click', function () {
      host.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  function summaryHTML() {
    var st = state.stats;
    var total = st.total;

    var rows = '';
    for (var s = 5; s >= 1; s--) {
      var c = Number(st.dist[s] || 0);
      var pct = total ? Math.round((c / total) * 100) : 0;
      rows += '<button type="button" class="kwd-rv-row" data-star="' + s + '"' +
        ' aria-pressed="' + (state.filter === s ? 'true' : 'false') + '"' +
        ' aria-label="Show only ' + s + ' star reviews">' +
        '<span class="lab">' + s + ' star' + (s === 1 ? '' : 's') + '</span>' +
        '<span class="trk"><i style="width:' + pct + '%"></i></span>' +
        '<span class="n">' + c + '</span></button>';
    }

    return '<div class="kwd-rv-top">' +
      '<div class="kwd-rv-score">' +
        '<div class="kwd-rv-num">' + st.avg.toFixed(1) + '</div>' +
        stars(st.avg) +
        '<div class="kwd-rv-outof">out of 5</div>' +
        '<div class="kwd-rv-count">' + total + ' review' + (total === 1 ? '' : 's') +
          (st.verified ? ' &middot; ' + st.verified + ' verified' : '') + '</div>' +
      '</div>' +
      '<div class="kwd-rv-dist">' + rows + '</div>' +
    '</div>';
  }

  function cardHTML(r) {
    var badge = r.verified_buyer
      ? '<span class="kwd-rv-badge"><svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"/></svg>Verified buyer</span>'
      : '';
    var help = (r.votes_up > 0)
      ? '<div class="kwd-rv-help">' + r.votes_up + ' person' + (r.votes_up === 1 ? '' : 's') + ' found this helpful</div>'
      : '';
    var title = r.title ? '<p class="kwd-rv-title">' + esc(r.title) + '</p>' : '';

    return '<article class="kwd-rv-item">' +
      '<div class="kwd-rv-head">' + stars(r.score) +
        '<span class="kwd-rv-who">' + esc(firstName(r.user && r.user.display_name)) + '</span>' +
        badge +
        '<span class="kwd-rv-when">' + when(r.created_at) + '</span>' +
      '</div>' + title +
      '<p class="kwd-rv-body">' + esc(r.content) + '</p>' + help +
    '</article>';
  }

  function emptyHTML() {
    return '<div class="kwd-rv-empty">' +
      '<h3>No reviews on this bottle yet</h3>' +
      '<p>If you have had this one, a couple of lines genuinely helps the next person decide.</p>' +
      '<button type="button" class="kwd-rv-write">Write the first review</button>' +
    '</div>';
  }

  function render() {
    if (!state.all.length) { host.innerHTML = emptyHTML(); wire(); return; }

    var list = visible();
    var slice = list.slice(0, state.shown);
    var cards = slice.map(cardHTML).join('');
    var more = (list.length > state.shown)
      ? '<button type="button" class="kwd-rv-more">Show ' +
        Math.min(PAGE, list.length - state.shown) + ' more of ' + list.length + '</button>'
      : '';

    host.innerHTML = summaryHTML() +
      '<div class="kwd-rv-bar">' +
        '<h3>' + (state.filter ? state.filter + ' star reviews' : 'What people said') + '</h3>' +
        '<button type="button" class="kwd-rv-clear' + (state.filter ? ' on' : '') + '">&times; Clear filter</button>' +
        '<select class="kwd-rv-sort" aria-label="Sort reviews">' +
          '<option value="recent">Most recent</option>' +
          '<option value="high">Highest rated</option>' +
          '<option value="low">Lowest rated</option>' +
          '<option value="helpful">Most helpful</option>' +
        '</select>' +
        '<button type="button" class="kwd-rv-write">Write a review</button>' +
      '</div>' +
      '<div class="kwd-rv-list">' + cards + '</div>' + more;

    var sel = host.querySelector('.kwd-rv-sort');
    if (sel) { sel.value = state.sort; }
    wire();
  }

  function visible() {
    var a = state.all;
    if (state.filter) {
      a = a.filter(function (r) { return Math.round(r.score) === state.filter; });
    }
    return sorted(a);
  }

  function sorted(list) {
    var a = list.slice();
    if (state.sort === 'high') { a.sort(function (x, y) { return y.score - x.score; }); }
    else if (state.sort === 'low') { a.sort(function (x, y) { return x.score - y.score; }); }
    else if (state.sort === 'helpful') { a.sort(function (x, y) { return (y.votes_up || 0) - (x.votes_up || 0); }); }
    else { a.sort(function (x, y) { return new Date(y.created_at) - new Date(x.created_at); }); }
    return a;
  }

  function wire() {
    host.querySelectorAll('.kwd-rv-row').forEach(function (b) {
      b.addEventListener('click', function () {
        var s = Number(b.getAttribute('data-star'));
        state.filter = (state.filter === s) ? 0 : s;
        state.shown = PAGE;
        render();
      });
    });

    var clear = host.querySelector('.kwd-rv-clear');
    if (clear) {
      clear.addEventListener('click', function () {
        state.filter = 0; state.shown = PAGE; render();
      });
    }

    var sel = host.querySelector('.kwd-rv-sort');
    if (sel) {
      sel.addEventListener('change', function () {
        state.sort = sel.value; state.shown = PAGE; render();
      });
    }

    var more = host.querySelector('.kwd-rv-more');
    if (more) {
      more.addEventListener('click', function () { state.shown += PAGE; render(); });
    }

    host.querySelectorAll('.kwd-rv-write').forEach(function (b) {
      b.addEventListener('click', function () {
        var box = document.querySelector('.kwd-rv-yotpo');
        if (!box) { return; }
        box.classList.add('on');
        box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  host.innerHTML = '<div class="kwd-rv-load">Loading reviews...</div>';

  fetch('https://api-cdn.yotpo.com/v1/widget/' + APP_KEY + '/products/' + productId + '/reviews?per_page=' + PER_PAGE)
    .then(function (r) { return r.json(); })
    .then(function (j) {
      var res = (j && j.response) || {};
      state.all = res.reviews || [];
      state.stats = computeStats(state.all, res.bottomline);
      renderMini(state.stats);
      render();
    })
    .catch(function () {
      /* If Yotpo is unreachable, fall back to their own widget rather than
         showing a broken empty state. */
      host.innerHTML = '';
      var box = document.querySelector('.kwd-rv-yotpo');
      if (box) { box.classList.add('on'); }
    });
})();
